var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3536 4.03556C10.5488 3.8403 10.5488 3.52372 10.3536 3.32845L7.17157 0.146474C6.97631 -0.0487887 6.65973 -0.0487887 6.46447 0.146473C6.2692 0.341736 6.2692 0.658318 6.46447 0.85358L9.29289 3.68201L6.46447 6.51043C6.2692 6.7057 6.2692 7.02228 6.46447 7.21754C6.65973 7.4128 6.97631 7.4128 7.17157 7.21754L10.3536 4.03556ZM0 3.68201L-4.37114e-08 4.18201L10 4.18201L10 3.68201L10 3.18201L4.37114e-08 3.18201L0 3.68201Z",
    fill: "#E6E7EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine3);
export default __webpack_public_path__ + "static/media/Line3.550b3e76bf11f56b75d9236dabcb9706.svg";
export { ForwardRef as ReactComponent };